import React, { useState } from 'react';
import { Body, ExternalLink } from '@grnhse/seedling/lib/birch/typography';
import { CompactRow } from '@grnhse/seedling/lib/birch/layouts/compact_row';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import {
  PrimaryButton,
  DangerButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import ArrowRightIcon from '@grnhse/seedling/lib/birch/icons/arrow_right';
import { withLocalePrefix } from '../shared/utils/translation';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  accountSettingsUrl: string;
  onCancel: () => void;
  error?: string;
  email?: string;
};

export default function AuthorizeAction({
  accountSettingsUrl,
  onCancel,
  error,
  email,
}: Props) {
  const [emailValue, setEmailValue] = useState(email);
  const emailInputField = document.getElementById('email') as HTMLInputElement;

  return (
    <>
      {/* EmailValidationGuard checks for this field to know if the email needs to be validated
      and to return an error message if it is invalid */}
      <input type={'hidden'} name={'validate_email'} value={'true'} />
      <Stack>
        <TextInput
          className="pii-blur"
          onChange={(e) => {
            const value = e.target.value.trim();
            setEmailValue(value);
            emailInputField.value = value;
          }}
          value={emailValue}
          label={t('email')}
          helperText={error}
          error={!!error}
          required
        />
        <Body>
          {t('revoke_access_info')}{' '}
          <ExternalLink href={accountSettingsUrl}>
            {t('account_settings')}
          </ExternalLink>
        </Body>
        <CompactRow>
          <PrimaryButton
            type={'submit'}
            icon={ArrowRightIcon}
            iconPosition={'right'}
          >
            {t('login')}
          </PrimaryButton>
          <DangerButton onClick={onCancel}>{t('cancel')}</DangerButton>
        </CompactRow>
      </Stack>
    </>
  );
}
